import { panelApi } from "./api";

const TOKEN_KEY = "pm_panel_token";
const PANEL_KEY = "pm_panel_account";

const panelAuthService = {
  login: (payload) => panelApi.post("/panel-auth/login", payload).then((r) => r.data),
  me: () => panelApi.get("/panel-auth/me").then((r) => r.data),

  saveSession: ({ token, panel }) => {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(PANEL_KEY, JSON.stringify(panel));
  },
  getToken: () => localStorage.getItem(TOKEN_KEY),
  getPanel: () => {
    try {
      return JSON.parse(localStorage.getItem(PANEL_KEY) || "null");
    } catch {
      return null;
    }
  },
  logout: () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(PANEL_KEY);
  },
};

export default panelAuthService;
